import {ReactNode, useState} from 'react';
import Tabs, {Tab} from 'patient-ping-remedy/packages/tabs';
import styled from '@emotion/styled';
import QueueMappingsTab from '@/components/pages/settings/telephony/QueueMappingsTab';
import CampaignConfigsTab from '@/components/pages/settings/telephony/CampaignConfigsTab';
import VoiceMailConfigsTab from '@/components/pages/settings/telephony/VoiceMailConfigsTab';

const StyledTabs = styled(Tabs)`
  display: flex;
  gap: 0.8rem;
  padding-top: 0;
  margin-bottom: 1.4rem;
  border: none;
`;

const TELEPHONY_TABS = [
  {key: 'queue_mappings', label: 'Queue Mappings', content: () => <QueueMappingsTab />},
  {key: 'campaign_configs', label: 'Campaign Configs', content: () => <CampaignConfigsTab />},
  {key: 'voicemail_configs', label: 'Voicemail Configs', content: () => <VoiceMailConfigsTab />},
] as ReadonlyArray<{key: string; label: string; content: () => ReactNode}>;

type SubTab = typeof TELEPHONY_TABS[number]['key'];

export default function TelephonySettings() {
  const [activeTab, setActiveTab] = useState<SubTab>(TELEPHONY_TABS[0].key);
  const activeIndex = TELEPHONY_TABS.findIndex(tab => tab.key === activeTab);

  return (
    <>
      <StyledTabs value={activeIndex} onChange={(index) => setActiveTab(TELEPHONY_TABS[index].key)}>
        {TELEPHONY_TABS.map(tab => <Tab key={tab.key}>{tab.label}</Tab>)}
      </StyledTabs>
      {TELEPHONY_TABS[activeIndex].content()}
    </>
  );
}
